import { fromJS } from 'immutable'
import {
  COMPANY_LIST_REQUEST,
  COMPANY_LIST_SUCCESS,
  COMPANY_LIST_FAILURE,
  COMPANY_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case COMPANY_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case COMPANY_LIST_SUCCESS:
      return state
        .set('company', fromJS(action.payload.companys))
        .set('isFetching', false)
    case COMPANY_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case COMPANY_LIST_RESET:
      return state
        .set('redirect', false)
        .delete('company')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/company/company-list-reducer.js